import React, { useContext, useState, useEffect } from 'react';
import './AddCreditMemoPopup.css';
import cn from "classnames";
import styles from './AddCreditMemoPopup.module.sass';
import Modal from '@mui/material/Modal';
import Card from '../../../components/Card';
import { GlobalState } from '../../../App';
import TextInput from '../../../components/TextInput';
import { validate_if_not_empty } from '../../../utils/extensions';
import Icon from '../../../components/Icon';
import { updateOrderCreditMemoById } from '../../../Firebase/firebaseDatabase';
import LoadingDialog from '../../../LoadingScreen/LoadingDialog';
// import { Timestamp } from 'firebase/firestore';


const AddCreditMemoPopup = ({ data, memoDescription }) => {
  console.log(data)
  const { setIsClickedSave,
    showModalView, setShowModalView
  } = useContext(GlobalState)

  useEffect(() => {
    setIsClickedSave(false)
  }, [])

  const handleClose = () => {
    setShowModalView(false);
  }

  const [description, setDescription] = useState(memoDescription)
  const [loading, setLoading] = useState(false)

  const createCreditMemo = () => {
    data[0].data.creditMemo = description
    // data[0].data.dateCreated = Timestamp.now()
    delete data[0].data.dateCreated
    updateOrderCreditMemoById(data[0].data.id, data[0].data).then(res => {
      if (res === true) {
        setLoading(false)
        setShowModalView(false)
      }
    })
  }
  // setIsClickedSave(true)
  // setShowModalView(false)
  return (
    <Modal
      disableAutoFocus={true}
      open={showModalView}
      onClose={handleClose}
      className='dialog-wrapper'
      sx={{
        outline: '0 !important',
        border: 'none !important'
      }}
    >
      {
        loading ? <LoadingDialog /> :
          <Card
            className={cn(styles.card)}
            title="Enter Credit Memo"
            classTitle="title-green"
            classCardHead={styles.cardHead}
            head={
              <div style={{
                display: 'flex',
                gap: '12px'
              }}>

                <button
                  onClick={() => {
                    if (validate_if_not_empty(description, "creditMemoDescPopupErrId")) {
                      setLoading(true)
                      createCreditMemo()
                    }
                  }}
                  className={cn("button", styles.button)} >
                  <span>Save</span>
                </button>
                <button
                  onClick={() => {
                    setShowModalView(false)
                  }}
                  className={cn(styles.closeButton)} >
                  <Icon name="close" fill="red" size="16" />
                </button>
              </div>

            }
          >
            <div className={cn(styles.fieldContainer, styles.titleEnFieldContainer)}>
              <TextInput
                className={styles.field}
                classInput={styles.fieldInput}
                label="Description"
                name="popupCreditMemoDesc"
                type="text"
                onChange={(e) => { setDescription(e.target.value) }}
                value={description}
                required
              />
              <p className={styles.errField} id="creditMemoDescPopupErrId"></p>
            </div>

          </Card>
      }



    </Modal>

  )
}

export default AddCreditMemoPopup